import React, { useState, useEffect } from 'react';
import { Edit, CloseIcon } from '../../../assets/icons';
import { Switch, Modal, Button, Radio, Space } from 'antd';
import { useOutletContext } from 'react-router-dom';

import { getEmailPreferences, setEmailPreferences } from '../../../services/AccountApi/settingsApi';
import { toastNotify } from '../../../utils/toastNotify';
import './Settings.scss';

const Settings = () => {
  const { setLoading } = useOutletContext();
  const [emailSwitch, setEmailSwitch] = useState({
    generalCommunication: true,
    stmtTradeConfirmation: true,
    smsCommunication: true,
    leagalMatters: true,
    frequency: 'daily',
  });
  const [switchLoading, setSwitchLoading] = useState({
    generalCommunication: false,
    stmtTradeConfirmation: false,
    smsCommunication: false,
  });
  const [disclosureOpen, setDisclosureOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    // userData?.userData?.isKYCVerified && fetchEmailPrefData();
    fetchEmailPrefData();

  }, []);
  // destructured state variables
  const { generalCommunication, stmtTradeConfirmation, frequency } = emailSwitch;
  const [genComFrequency, setGenComFrequency] = useState(frequency);
  //get email preferences and update state
  const fetchEmailPrefData = async () => {
    setLoading(true);
    try {
      const resp = await getEmailPreferences();
      const data = resp.data;
      if (!resp.isError) {
        setEmailSwitch({ ...data });
        setGenComFrequency(data.frequency);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  //set email preferences and frequency and update state
  const handleEmailPref = async (pref) => {
    const { notificationType, isActive } = pref;
    setLoader(true);
    setSwitchLoading({ ...switchLoading, [notificationType]: true });
    try {
      const resp = await setEmailPreferences(pref);
      if (!resp.isError) {
        if(notificationType !== 'smsCommunication')
        {
        setEmailSwitch({ ...emailSwitch, [notificationType]: isActive, frequency: pref.frequency });
        toastNotify('success', resp?.message);
        }else{
          setEmailSwitch({ ...emailSwitch, [notificationType]:isActive})
          toastNotify('success', resp?.message);
        }
      } else {
        setGenComFrequency(frequency);
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      setGenComFrequency(frequency);
      toastNotify('error', response?.data?.message);
    }
    setSwitchLoading({ ...switchLoading, [notificationType]: false });
    setLoader(false);
    setDisclosureOpen(false);
  };

  return (
    <div className='settings'>
      <h4 className='settings__title'>Email Preferences</h4>
      <div className='settings__section'>
        <div className='settings__section__title '>
          <p className='fw-600 text-almost-black'>General Communication</p>
          <Edit color='#726460' onClick={() => setDisclosureOpen(true)} />
        </div>
        <div className='settings__section__title-details'>
          <p>Get updates on upcoming properties, market trends, and Realbricks updates.</p>
        </div>
        <div className='settings__section__title settings__section__title--subtitle'>
          <p className='text-almost-black'>Email</p>
          <Switch
            loading={switchLoading.generalCommunication}
            checked={generalCommunication}
            onChange={(e) =>
              handleEmailPref({
                notificationType: 'generalCommunication',
                frequency,
                isActive: e,
              })
            }
          />
        </div>
        <div className='settings__section__title settings__section__title--subtitle'>
          <p className='text-almost-black'>Frequency</p>
          <span role='button' className='label'>
            {frequency}
          </span>
        </div>
        <div className='settings__section__title settings__section__title--subtitle'>
          <p className='text-almost-black'>SMS</p>
          <Switch
            loading={switchLoading.smsCommunication}
            checked={emailSwitch.smsCommunication}
            onChange={(e) =>
              handleEmailPref({
                notificationType: 'smsCommunication',
                isActive: e,
              })
            }
          />
        </div>
      </div>
      <div className='settings__section'>
        <div className='settings__section__title '>
          <p className='fw-600 text-almost-black'>Statements & Trade Confirmations</p>
        </div>
        <div className='settings__section__title-details'>
          <p>
            Get notified about new account statements, when your buy and sell orders are complete, or when a bid is logged for a property you own.
          </p>
        </div>
        <div className='settings__section__title settings__section__title--subtitle'>
          <p className='text-almost-black'>Email</p>
          <Switch
            loading={switchLoading.stmtTradeConfirmation}
            checked={stmtTradeConfirmation}
            onChange={(e) =>
              handleEmailPref({
                notificationType: 'stmtTradeConfirmation',
                frequency,
                isActive: e,
              })
            }
          />
        </div>
      </div>
      <div className='settings__section'>
        <div className='settings__section__title '>
          <p className='fw-600 text-almost-black'>Legal Matters</p>
        </div>
        <div className='settings__section__title-details'>
          <p>Receive yearly tax documents, updates to terms and conditions, and other legal correspondence.</p>
        </div>
        <div className='settings__section__title settings__section__title--subtitle'>
          <p className='text-almost-black'>Email</p>
          <Switch defaultChecked disabled />
        </div>
      </div>
      <Modal
        open={disclosureOpen}
        onOk={() => setDisclosureOpen(false)}
        onCancel={() => {
          setDisclosureOpen(false);
          setGenComFrequency(frequency);
        }}
        footer={false}
        width={434}
        closeIcon={<CloseIcon />}
        centered
      >
        <p className='mb-24 subhead-1 text-center'>How often would you like to receive emails for general communications?</p>
        <p className='mb-12'>
          Set the frequency that you would you like to receive updates on upcoming properties, market trends, and Realbricks updates.
        </p>
        <Radio.Group className='vertical-radio' value={genComFrequency} onChange={(e) => setGenComFrequency(e.target.value)}>
          <Space direction='vertical' size={22}>
            <Radio value={'daily'}>Daily</Radio>
            <Radio value={'weekly'}>Weekly</Radio>
            <Radio value={'monthly'}>Monthly</Radio>
          </Space>
        </Radio.Group>
        <div className='mb-48' />
        <Button
          type='primary'
          className='w-100'
          loading={loader}
          // Adding this as per this issue A0TG-I1193
          disabled={frequency === genComFrequency}
          onClick={() =>
            handleEmailPref({
              notificationType: 'generalCommunication',
              frequency: genComFrequency,
              isActive: generalCommunication,
            })
          }
        >
          Confirm
        </Button>
      </Modal>
    </div>
  );
};

export default Settings;
